export default "__VITE_ASSET__C7mK4AgH__"